import React from "react";
import { Typography, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import queryString from "query-string";

const { Title, Text } = Typography;

interface ComplaintHeaderProps {
  complaintNumber: string;
  isComplaint?: boolean;
  client: string;
  hasClient?: boolean;
  status?: "active" | "inactive";
  backRoute: string;
}

const ComplaintHeader: React.FC<ComplaintHeaderProps> = ({
  complaintNumber,
  isComplaint = true,
  hasClient = true,
  client,
  status,
  backRoute,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { byCase } = queryString.parse(window.location.search);

  return (
    <div className="bg-white border-b border-gray-200 py-2">
      <div className="flex flex-row md:items-center justify-between gap-3">
        <div className="flex items-center gap-3 md:gap-4">
          {(!byCase || byCase !== "true") && (
            <Button
              type="text"
              icon={<ArrowLeft />}
              size="large"
              onClick={() => navigate(backRoute)}
            />
          )}
          <div>
            <Title level={3} className="!mb-1 !text-lg md:!text-2xl">
              {isComplaint && t("complaint")} {complaintNumber}
            </Title>
            <Text type="secondary" className="text-sm md:text-base">
              {hasClient ? t("client") + ": " + client : client}
            </Text>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {status && (
            <div
              className={`w-3 h-3 md:w-4 md:h-4 rounded-full ${
                status === "active" ? "bg-green-500" : "bg-gray-400"
              }`}
              title={status}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ComplaintHeader;
